import React from 'react';

interface TelemetryNotFoundProps {
  message?: string;
  description?: string;
}

export const TelemetryNotFound: React.FC<TelemetryNotFoundProps> = ({ message, description }) => {
  return (
    <div className="telemetry-dashboard-not-found-container">
      <div className="telemetry-dashboard-not-found-card">
        <svg className="telemetry-not-found-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="9" y1="15" x2="15" y2="15" />
        </svg>
        <div className="telemetry-not-found-title">{message ?? 'Dashboard Not Found'}</div>
        <div className="telemetry-not-found-subtitle">
          {description ?? 'Telemetry dashboard configuration or parameter catalog API data could not be loaded for this satellite.'}
        </div>
      </div>
    </div>
  );
};

export default TelemetryNotFound;
